var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
function MediaContainer(_a) {
    var children = _a.children, _b = _a.aspectRatio, aspectRatio = _b === void 0 ? '16 / 9' : _b, _c = _a.height, height = _c === void 0 ? 'auto' : _c, _d = _a.width, width = _d === void 0 ? 'auto' : _d, _e = _a.className, className = _e === void 0 ? '' : _e;
    return (_jsx("div", __assign({ className: clsx('rounded-lg overflow-hidden', className), style: {
            width: width,
            height: height,
            aspectRatio: aspectRatio,
        } }, { children: children })));
}
export default MediaContainer;
